import FingerprintJS from '@fingerprintjs/fingerprintjs-pro/dist/fp.esm.min'
import {useMerchantStore} from '@src/store/merchant'
import {sentryCaptureMessageFiltered} from '@src/utility/sentry'

import {FingerprintjsGet} from './type'

const disabled = import.meta.env.VITE_ENVIRONMENT === 'development'

/* eslint-disable @typescript-eslint/no-explicit-any */
let fpPromise: Promise<any>

const FINGERPRINT_KEY = import.meta.env.VITE_FINGERPRINT_KEY ?? ''
const FINGERPRINT_ENDPOINT = import.meta.env.VITE_FINGERPRINT_ENDPOINT ?? ''

export async function fingerprintjsLoad(): Promise<void> {
  const {setDeviceId, setFingerprintError} = useMerchantStore.getState()

  if (disabled) return

  try {
    fpPromise = FingerprintJS.load({
      apiKey: FINGERPRINT_KEY,
      endpoint: FINGERPRINT_ENDPOINT
    })

    const fp: any = await fpPromise

    const result: any = await fp?.get()

    setDeviceId(result.visitorId)
  } catch (error) {
    setFingerprintError(true)
    sentryCaptureMessageFiltered(error as Error, 'error in fingerprint load')
  }
}

export const fingerprintjsGet: FingerprintjsGet = tag => {
  const {setDeviceId} = useMerchantStore.getState()

  if (disabled || !fpPromise) return

  fpPromise
    .then(fp => fp.get({tag: {...tag, from: 'AOM'}}))
    .then(result => {
      if (result?.visitorId) {
        setDeviceId(result.visitorId)
      }
      return result
    })
    .catch(error => {
      sentryCaptureMessageFiltered(error, 'error in get fingerprint')
      return error
    })
}
